export const messages = {
  button: {
    cancel: { id: 'admin/promotions.utils.cancel' },
    add: { id: 'admin/promotions.utils.add' },
    apply: { id: 'admin/promotions.utils.apply' },
  },
}
